import React from "react"
import styled from "styled-components"
import ContactInfo from "../Atoms/ContactInfo"
import { location, mail, phone } from "../res/imgs/icons/index"
import { useTranslation } from "react-i18next"
import Colors from "../res/styles/Colors"
import { SmInfos, FooterLogo } from "../res/styles/TextStyles"
import { Container, Col, Row } from "../res/styles/Common"
import { LanguageSelector } from "."

const Background = styled.div`
    background-color: ${Colors.red};
`

const TopSection = styled.div`
    text-align: center;
    padding: 60px 0;

    & img {
        max-width: 450px;
        width: 100%;
        height: auto;
    }
`

const BottomSection = styled.div`
    text-align: center;
    padding: 30px;
`

function Footer() {
    const { t } = useTranslation()

    return (
        <Background>
            <TopSection>
                <FooterLogo>WOOL CASHMERE PRATESE</FooterLogo>
            </TopSection>
            <Container>
                <Row>
                    <Col>
                        <ContactInfo
                            link={`http://maps.google.com/?q=${t("address_2")}`}
                            img={location}
                            text={t("legal_site") + t("address_2")}
                        />
                        <ContactInfo
                            link={`http://maps.google.com/?q=${t("address")}`}
                            img={location}
                            text={t("upo") + t("address")}
                        />
                    </Col>
                    <Col>
                        <ContactInfo
                            link={`tel:${t("phone_number")}`}
                            img={phone}
                            text={t("phone_number")}
                        />
                        <ContactInfo
                            link={`mailto:${t("email")}`}
                            img={mail}
                            text={t("email")}
                        />
                    </Col>
                    <Col>
                        <LanguageSelector>ITALIANO</LanguageSelector>
                        {/* <h5>LOGO CERTIFICAZIONE</h5> */}
                    </Col>
                </Row>
            </Container>
            <BottomSection>
                <SmInfos>
                    Wool Cashmere Pratese Srl<br></br>
                    Capitale Sociale I.V. 50.000,00 Euro<br></br>
                    P.IVA - CF 01981880477 REA n° PT 0196345
                </SmInfos>
            </BottomSection>
        </Background>
    )
}

export default Footer
